import HfReactHelper from 'hellosign/components/hf-react-helper';

let CSRFToken: string;

export function setCsrfToken(csrfToken: string) {
  CSRFToken = csrfToken;
}
export function getCSRFToken(): string {
  return CSRFToken;
}

export function needsCSRFToken(url: string) {
  try {
    return new URL(url, window.location.href).host === document.domain;
  } catch (e) { // IE11
    const a = document.createElement('a');
    a.href = url;
    document.body.appendChild(a);

    // When I tested relative URLs in IE, they didn't have a host. If you use
    // something like `https://google.com/`, then it will actually have
    // google.com as the host.
    const needsToken = (a.host === '' || a.host === document.domain);
    document.body.removeChild(a);
    return needsToken;
  }
}

/* eslint-disable no-restricted-globals */
export default function hsFetch(url: string, options: RequestInit = {}): ReturnType<typeof fetch> {
  // If this is running in an iframe on another site, the browser may choose to
  // not include the "3rd party" cookies. This attaches the session info so the
  // session isn't lost.
  if (window.top !== window) {
    // eslint-disable-next-line no-param-reassign
    url = HfReactHelper.attachSessionInfoToUrl(url);
  }

  const requestHeaders: HeadersInit = {
    Accept: 'application/json',
    ...options.headers,
  };

  if (needsCSRFToken(url)) {
    // Adding global X-CSRF-Token
    (requestHeaders as any)['X-CSRF-Token'] = CSRFToken;
  }

  const requestOptions = {
    ...options,
  };

  requestOptions.headers = requestHeaders;

  return fetch(url, {
    credentials: 'same-origin',
    method: 'GET',
    ...requestOptions,
  });
}
